import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['description', 'name', 'rhythm'];

  fillName() {
    const select = this.rhythmTarget;

    this.nameTarget.value = select.options[select.selectedIndex].label;
    this.descriptionTarget.focus();
  }
}
